define(function (require) {
    "use strict";
    var BaseFeatureController = require("personalization-controllers/BaseFeatureController");
    var SLAEditView = require("personalization-web-agent-views/SLAEditView");
    var Settings = require("codeTables/settings.json");
    var ERROR_CODES = require("codeTables/errorCodes.json");
    var SLAEditController={};

    LE.module('LEPersonalization', function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        SLAEditController = BaseFeatureController.extend({
            initialize: function (options) {
                LEPersonalization.logger.info("initializing", "SLAEditController:initialize. options = " + options);
                this.settingsCollection = options.settingsCollection;
                this.slaEditView = new SLAEditView({
                    anchorSelector: options.featureOptions.anchorSelector,
                    settingsCollection: options.settingsCollection
                });
                this.listenTo(this.slaEditView,"sla:save",this._save,this);
            },

            getEditView:function(options){
                LEPersonalization.logger.debug("return this view", "SLAEditController:getEditView. options = " + options);
                return this.slaEditView;
            },

            _save:function(options){
                LEPersonalization.logger.debug("perform save if UI error validations pass", "SLAEditController:_save. options = " + options);
                if (!this.slaEditView.isErrorView()) {
                    LEPersonalization.loader.setLoader();
                    this._saveSiteSettings(options);
                } else {
                    LEPersonalization.notifier.showError({
                        content: LE.translator.translate("LEFramework.errors.generalError.on.page"),
                        timeToShow: 6000
                    });
                }
            },
            _showNotifierError: function(response) {
                if(response && response.responseError && response.responseError.code === ERROR_CODES.wrongRevision) {
                    LEPersonalization.notifier.showError(LE.translator.translate("LEFramework.errors.serverError.1001"));
                } else {
                    LEPersonalization.notifier.showError(LE.translator.translate("LEFramework.errors.serverError.1100"));
                }
            },

            _saveSiteSettings: function(options) {
                options = options || [];
                LEPersonalization.logger.debug("save site settings", "SLAEditController:_saveSiteSettings.");
                this.settingsCollection.get(Settings.SETTING_ID.DEFAULT_SLA_RESPONSE_TIME).setValue(options[Settings.SETTING_ID.DEFAULT_SLA_RESPONSE_TIME]);
                this.settingsCollection.get(Settings.SETTING_ID.URGENT_SLA_RESPONSE_TIME).setValue(options[Settings.SETTING_ID.URGENT_SLA_RESPONSE_TIME]);
                this.settingsCollection.get(Settings.SETTING_ID.FIRST_TIME_SLA_RESPONSE_TIME).setValue(options[Settings.SETTING_ID.FIRST_TIME_SLA_RESPONSE_TIME]);
                this.settingsCollection.get(Settings.SETTING_ID.DEFAULT_SLA_UNITS).setValue(options[Settings.SETTING_ID.DEFAULT_SLA_UNITS]);
                this.settingsCollection.get(Settings.SETTING_ID.URGENT_SLA_UNITS).setValue(options[Settings.SETTING_ID.URGENT_SLA_UNITS]);
                this.settingsCollection.get(Settings.SETTING_ID.FIRST_TIME_SLA_UNITS).setValue(options[Settings.SETTING_ID.FIRST_TIME_SLA_UNITS]);
                this.settingsCollection.get(Settings.SETTING_ID.AUTO_CLOSE_TIME_SEC).setValue(options[Settings.SETTING_ID.AUTO_CLOSE_TIME_SEC]);

                this.settingsCollection.update({
                    success: _.bind(this._onSaveSuccess, this),
                    error: _.bind(this._onSaveError, this)
                });
            },

            _onSaveSuccess: function (model, response, options) {
                LEPersonalization.logger.debug("When data fetch was successful", "SLAEditController:_onSaveSuccess. response = " + response);
                LEPersonalization.loader.closeLoader();
                LEPersonalization.navigateToPageMenu();
            },
            _onSaveError: function (model, response, options) {
                LEPersonalization.logger.debug("When data fetch has resulted with an error", "SLAEditController:_onSaveError. response = " + response);
                this._showNotifierError(response);
                LEPersonalization.loader.closeLoader();
            }
        });
    });
    return SLAEditController;

});
